import CityPageTemplate from "../city-template/CityPageTemplate";
import { dickinsonConfig } from "./data";

export default function DickinsonPage() {
  return <CityPageTemplate config={dickinsonConfig} />;
}